import { render, staticRenderFns } from "./LoadingSpinner.vue?vue&type=template&id=08b940da&scoped=true"
import script from "./LoadingSpinner.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoadingSpinner.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LoadingSpinner.vue?vue&type=style&index=0&id=08b940da&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b940da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08b940da')) {
      api.createRecord('08b940da', component.options)
    } else {
      api.reload('08b940da', component.options)
    }
    module.hot.accept("./LoadingSpinner.vue?vue&type=template&id=08b940da&scoped=true", function () {
      api.rerender('08b940da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/LoadingSpinner.vue"
export default component.exports